import { Component, OnInit, Input, Renderer2, ElementRef, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ModalService } from './modal.service';
import { defaultConfigModal } from './modal.config';

@Component({
  selector: 'q-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})

export class ModalComponent implements OnInit, OnDestroy {

  /**
   * @description Définit le z-index pour une modal z-index: number (paramètre optionnel)
   * @example 1060
   * @default 1000
   * */
  @Input('z-index') zIndex: number;
  /**
   * Définit le margin-top de la modal
   *
   * formats prient en charges : 'center' / 'px' / '%'
   *
   * Configuration par défaut : 'center'
  */
  @Input('top') top: string;
  /**
   * Définit la width de la modal selon des classes bootstrap de la grid
   *
   * format pris en charges : 'col-1 col-sm-2 col-md-2 col-ls-4 col-xl-3'
   *
   * Configuration par défaut : 'col-10 col-sm-10 col-md-6 col-ls-7 col-xl-8'
  */
  @Input('width') width: string;
  /**
   * Définit la height de la modal
   *
   * formats prient en charges : 'auto' / 'Large'(80%) / 'Medium'(60%) / 'Small'(40%) / 'px' / '%'
   *
   * Configuration par défaut : 'auto'
  */
  @Input('height') height: string;
  /**
   * Définit l'id de la modal
   *
   * Permet d'identifier la modal
  */
  @Input('id') id: string;

  /**
    * Permet de gérer le display block/none directement dans le html
  */

  @Output() closeModal: EventEmitter<string> = new EventEmitter<string>();

  public visible: boolean;

  /**
    * Permet au variables de style de se charger avant l'affichage du template
  */
  public load: boolean;

  /**
     * correspond à 'col'
  */
  public xs: string;
  /**
     * correspond à 'col-sm'
  */
  public sm: string;
  /**
     * correspond à 'col-md
  */
  public md: string;
  /**
     * correspond à 'col-ls'
  */
  public ls: string;
  /**
     * correspond à 'col-xl'
  */
  public xl: string;
  /**
     * correspond à center
  */
 public center: boolean;

  @ViewChild('content', { static: false }) content: ElementRef;

  /**
   * @ignore
  */
  constructor(
    private render: Renderer2,
    private element: ElementRef,
    private modalService: ModalService,
  ) {}

  /**
   * @ignore
  */
  ngOnInit(): void {
    this.zIndex = this.zIndex ? this.zIndex : 1030;
    this.load = false;
    this.visible = false;
    // Configuration de la modal
    this.height = defaultConfigModal(this.height, this.top, this.width).height;
    this.top = defaultConfigModal(this.height, this.top, this.width).top;
    this.xs = defaultConfigModal(this.height, this.top, this.width).xs;
    this.sm = defaultConfigModal(this.height, this.top, this.width).sm;
    this.md = defaultConfigModal(this.height, this.top, this.width).md;
    this.ls = defaultConfigModal(this.height, this.top, this.width).ls;
    this.xl = defaultConfigModal(this.height, this.top, this.width).xl;

    // Vérifie que l'id exist
    if (!this.id) {
        console.error('modal must have an id');
        return;
    }
    // Ajoute une instance de la modale au tableau dans le service
    this.modalService.add(this);

    this.load = true;
  }

  /**
   * @ignore
  */
  ngOnDestroy(): void {
      this.modalService.remove(this.id);
      this.element.nativeElement.remove();
  }

  /**
   * Ouvre une modale
   */
  public open(): void {
    // suppression de l'evenement global de scroll lorsque la modal est active
    this.render.setStyle(document.body, 'overflow', 'hidden');
    this.render.removeClass(this.content.nativeElement, 'animation-end');
    this.render.addClass(this.content.nativeElement, 'animation-begin');
    this.render.appendChild(document.body, this.element.nativeElement);
    this.visible = true;
  }

  /**
   * Ferme la modal
   */
  public close(): void {
    // activation de l'evenement global de scroll lorsque la modal est active
    this.render.setStyle(document.body, 'overflow', 'auto');
    this.render.removeClass(this.content.nativeElement, 'animation-begin');
    this.render.addClass(this.content.nativeElement, 'animation-end');
    setTimeout(() => {
      this.render.removeChild(document.body, this.element.nativeElement);
      this.visible = false;
    }, 200);
    this.closeModal.emit(this.id);
  }

  /**
   * retourne les col à binder dans le html
   */
  public getcols(): {xs: string, sm: string, md: string, ls: string, xl: string} {
    return {
      xs: this.xs,
      sm: this.sm,
      md: this.md,
      ls: this.ls,
      xl: this.xl
    };
  }

}

